import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { SaveStates } from 'editor-components/EPConstants';
import { TrellisEPSaveLabel } from 'editor-components/header/EPSaveLabel';
import { isLastSaveToday } from 'editor-components/utils/durationUtils';
import { useCallback } from 'react';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const useSaveLabelMessage = saveState => {
  return useCallback(({
    showLastSaved
  }) => {
    let message;
    switch (saveState) {
      case SaveStates.SAVING_CHANGES:
        message = 'epSaveLabel.saving';
        break;
      case SaveStates.AUTO_SAVED_CHANGES:
        {
          message = 'epSaveLabel.autoSaved';
          break;
        }
      case SaveStates.SAVED_CHANGES:
        {
          if (!showLastSaved) {
            message = 'epSaveLabel.saved';
          } else {
            message = 'epSaveLabel.save';
          }
          break;
        }
      case SaveStates.SAVE_FAILED:
        message = 'epSaveLabel.notSaved';
        break;
      default:
        message = 'epSaveLabel.save';
    }
    return message;
  }, [saveState]);
};
const EPSaveButton = ({
  iconColor,
  lastSave,
  onClick,
  renderTooltipContent,
  saveState,
  tooltipPlacement = 'bottom',
  tooltipUse = 'default',
  disabled,
  justifyLabel = 'end',
  statusIconPosition,
  CustomTooltip
}) => {
  const getMessage = useSaveLabelMessage(saveState);
  function getTooltipContent(now) {
    if (renderTooltipContent) {
      return renderTooltipContent(now);
    }
    let message;
    let lastSaveDate;
    let lastSaveDuration;
    if (lastSave) {
      if (isLastSaveToday({
        lastSave,
        now
      })) {
        message = 'epSaveLabel.savedAtToday';
      } else {
        message = 'epSaveLabel.savedAt';
      }
      lastSaveDate = /*#__PURE__*/_jsx(FormattedDateTime, {
        value: lastSave,
        format: "LL"
      });
      lastSaveDuration = /*#__PURE__*/_jsx(FormattedDuration, {
        to: lastSave,
        from: now,
        includeAffix: true
      });
      return /*#__PURE__*/_jsx(Text, {
        textWrap: "nowrap",
        as: "span",
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: message,
          options: {
            lastSaveDate,
            lastSaveDuration
          }
        })
      });
    }
    return null;
  }
  return /*#__PURE__*/_jsx(TrellisEPSaveLabel, {
    getMessage: getMessage,
    iconColor: iconColor,
    justifyLabel: justifyLabel,
    lastSave: lastSave,
    onClick: onClick,
    onDark: true,
    renderTooltipContent: getTooltipContent,
    saveState: saveState,
    tooltipPlacement: tooltipPlacement,
    tooltipUse: tooltipUse,
    disabled: disabled,
    statusIconPosition: statusIconPosition,
    CustomTooltip: CustomTooltip
  });
};
export const TrellisEPSaveButton = EPSaveButton;
export default EPSaveButton;